import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const SaleContactCreditDialogTourConfig: AgTechTourConfig = {
    id: 'contact-credit-dialog-tour',
    name: 'Credit Tour',
    steps: [
        {
            targetId: 'contact-credit-amount',
            title: 'Contact and Amount',
            description: 'The credit amount must be greater than zero. Credits can be applied to this contact invoices.',
            position: 'bottom',
        },
        {
            targetId: 'contact-credit-description',
            title: 'Description',
            description: 'Explain why the credit was given so it is clear when it appears on an invoice.',
            position: 'bottom',
        },
        {
            targetId: 'contact-credit-details',
            title: 'Expiration and Private Note',
            description: 'Turn on Expires to give the credit an end date. The private note is for your records only.',
            position: 'top',
        },
    ]
}
